export const buildArticleMap = (sections) => {
  const map = {};
  sections.forEach((section) => {
    section.chapters.forEach((chapter) => {
      chapter.articles.forEach((article) => {
        const key = `${section.slug}/${chapter.slug}/${article.slug}`;
        map[key] = { section, chapter, article };
      });
    });
  });
  return map;
};

export const buildArticleList = (sections) => {
  const list = [];
  sections.forEach((section) => {
    section.chapters.forEach((chapter) => {
      chapter.articles.forEach((article) => {
        list.push({
          key: `${section.slug}/${chapter.slug}/${article.slug}`,
          title: article.title,
        });
      });
    });
  });
  return list;
};
